<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div #dropDown data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" role="menu" (click)="addFocus()">
  <label class="form-label fs-14 text-default mb-1">{{ label }}</label>
  <h5>{{ selectedLocation ? selectedLocation.cityName : 'Select location' }}</h5>
  <p class="fs-12 mb-0">{{ selectedLocation?.cityName }}</p>
  <ng-content select="[location-picker-icon]"></ng-content>
</div>
<div class="dropdown-menu dropdown-md p-0 city-picker-menu">
  <!-- top header (visible on mobile as a sheet header) -->
  <div class="lp-menu-header d-flex align-items-center justify-content-between p-3 border-bottom">
    <h5 class="mb-0">Select City or Location</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeDropDown(dropDown)"></button>
  </div>

  <div class="input-search p-3 border-bottom">
    <div class="input-group">
      <input #searchInput type="text" class="form-control" placeholder="Search Location" [formControl]="searchInputControl"/>
      <span class="input-group-text px-2 border-start-0"><i class="isax isax-search-normal"></i></span>
    </div>
  </div>
    <div *ngIf="isLoading" class="skeleton-wrapper p-3">
    <div class="skeleton-item mb-3" *ngFor="let item of [1,2,3,4]">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div class="skeleton-title mb-2"></div>
          <div class="skeleton-text"></div>
        </div>
        <div class="skeleton-code"></div>
      </div>
    </div>
</div>
  <!-- No Data Found -->
  <div class="lp-empty" *ngIf="
    !isLoading &&
    searchInputControl.value?.length >= 3 &&
    (locations$ | async)?.length === 0
  ">
    <div class=" text-center">
      <p class="text-muted mb-0">No data found</p>
    </div>
  </div>
<!-- Main Content (Shown only when data loaded) -->
<div *ngIf="!isLoading">
  <!-- empty / placeholder area when there are no results or input is less than min chars -->
  <div class="lp-empty" *ngIf="(locations$ | async) === null">
    <div class="p-3">
      <a class="d-flex align-items-center text-primary mb-3" href="javascript:void(0)" (click)="useCurrentLocation(dropDown)">
        <i class="isax isax-locate me-2"></i>
        Use Current Location
      </a>
      <hr />
      <p class="text-muted mb-0">Enter 3 or more characters to search</p>
    </div>
  </div>
    <!-- Loader Section (Added) -->

  <ul>
    <li class="border-bottom" *ngFor="let location of locations$ | async">
      <a class="dropdown-item" href="javascript:void(0);" (click)="setLocation(location, dropDown)">
        <div class="d-flex justify-content-between">
          <div>
            <h5 class="fs-16 fw-medium">{{ location.cityName }}, {{ location.countryName }}</h5>
            <p>{{ location.cityName }}</p>
          </div>
        </div>
      </a>
    </li>
  </ul>
    </div>
</div>
